<template>
  <div class="particle-container" ref="container"></div>
</template>

<script>
export default {
  name: 'NeuralParticle',
  data() {
    return {
      CONFIG: {
        effect: 'default', // 效果类型
        effectMode: 0, // 效果模式
        particleSize: 193, // 粒子大小
        particleCount: 80000, // 粒子数量
        uploadedImage: null, // 上传的图片
        shape: 'default', // 形状类型
        interactionMode: 'auto', // 交互模式
        manualControlTarget: 'camera' // 手动控制目标
      },
      sceneData: null,
      uploadedImage: null,
      particleSize: 0,
      PARTICLE_COUNT: 0,
      currentEffect: '',
      currentShape: '',
      interactionMode: '',
      manualControlTarget: '',
      effectIntensity: 0,
      targetEffectIntensity: 0,
      explosionTriggered: false,
      explosionTime: 0,
      cameraControlState: {
        target: null,
        yaw: 0,
        pitch: 0,
        distance: 45,
        minDistance: 20,
        maxDistance: 100,
        isLeftDragging: false,
        isRightDragging: false,
        previousX: 0,
        previousY: 0
      },
      mouseState: { isDragging: false, previousX: 0, previousY: 0 },
      vertexShader: `uniform float uTime;uniform float uMorph;uniform float uPointSize;uniform int uEffectMode;uniform float uEffectIntensity;uniform float uExplosionTime;attribute vec3 targetPosition;attribute vec3 targetColor;attribute vec3 color;attribute vec3 randomOffset;varying vec3 vColor;varying float vDistance;vec3 mod289(vec3 x){return x-floor(x*(1.0/289.0))*289.0;}vec2 mod289(vec2 x){return x-floor(x*(1.0/289.0))*289.0;}vec3 permute(vec3 x){return mod289(((x*34.0)+1.0)*x);}float snoise(vec2 v){const vec4 C=vec4(0.211324865405187,0.366025403784439,-0.577350269189626,0.024390243902439);vec2 i=floor(v+dot(v,C.yy));vec2 x0=v-i+dot(i,C.xx);vec2 i1=(x0.x>x0.y)?vec2(1.0,0.0):vec2(0.0,1.0);vec4 x12=x0.xyxy+C.xxzz;x12.xy-=i1;i=mod289(i);vec3 p=permute(permute(i.y+vec3(0.0,i1.y,1.0)) + i.x + vec3(0.0,i1.x,1.0));vec3 m=max(0.5-vec3(dot(x0,x0),dot(x12.xy,x12.xy),dot(x12.zw,x12.zw)),0.0);m=m*m;m=m*m;vec3 x=2.0*fract(p*C.www)-1.0;vec3 h=abs(x)-0.5;vec3 ox=floor(x+0.5);vec3 a0=x-ox;m*=1.79284291400159-0.85373472095314*(a0*a0+h*h);vec3 g;g.x=a0.x*x0.x+h.x*x0.y;g.yz=a0.yz*x12.xz+h.yz*x12.yw;return 130.0*dot(m,g);}void main(){vColor=mix(color,targetColor,uMorph);vec3 pos=mix(position,targetPosition,uMorph);vec3 originalPos=pos;float effectMix=uEffectIntensity;if(uEffectMode==0){float noise=sin(uTime*1.5+position.x*0.3)*cos(uTime*1.5+position.y*0.3);pos+=normalize(pos)*noise*(0.2*(1.0-uMorph));pos.x+=sin(uTime*0.3+position.z)*0.1;pos.y+=cos(uTime*0.3+position.x)*0.1;}else if(uEffectMode==1){vec3 scatterDir=normalize(pos+randomOffset*0.5);float scatterDist=length(pos)*0.5+randomOffset.x*3.0;vec3 scattered=pos+scatterDir*scatterDist*effectMix*2.5;float turb=snoise(pos.xy*0.3+uTime*0.5);scattered+=vec3(turb,turb*0.5,turb*0.3)*effectMix*1.5;pos=mix(originalPos,scattered,effectMix);}else if(uEffectMode==2){float explodeProgress=min(uExplosionTime*2.0,1.0);float returnProgress=max(0.0,(uExplosionTime-0.5)*2.0);vec3 explodeDir=normalize(pos+randomOffset);float explodeDist=(5.0+randomOffset.x*8.0)*sin(explodeProgress*3.14159);vec3 exploded=originalPos+explodeDir*explodeDist*effectMix;float spin=explodeProgress*6.28318*(0.5+randomOffset.y);exploded.x+=cos(spin)*explodeDist*0.3;exploded.z+=sin(spin)*explodeDist*0.3;pos=mix(originalPos,exploded,effectMix*(1.0-returnProgress*0.7));}else if(uEffectMode==3){float angle=atan(pos.z,pos.x);float radius=length(pos.xz);float height=pos.y;float spiralSpeed=uTime*2.0+height*0.3;float newAngle=angle+spiralSpeed*effectMix;float vortexPull=(1.0-abs(height)/20.0)*effectMix;float newRadius=radius*(1.0-vortexPull*0.5)+sin(uTime*3.0+height)*effectMix;float lift=effectMix*5.0*(1.0-radius/20.0);pos.x=cos(newAngle)*newRadius;pos.z=sin(newAngle)*newRadius;pos.y=height+lift*sin(uTime+radius);}else if(uEffectMode==4){float pulsePhase=uTime*2.5;float pulseFactor=1.0+sin(pulsePhase)*0.4*effectMix;float waveFactor=sin(pulsePhase+length(pos)*0.3)*0.3*effectMix;vec3 pulsed=pos*pulseFactor;pulsed+=normalize(pos)*waveFactor*3.0;float colorPulse=sin(pulsePhase*0.5)*0.5+0.5;vColor=mix(vColor,vec3(1.0,0.4,0.8),colorPulse*effectMix*0.3);pos=pulsed;}else if(uEffectMode==5){float waveX=sin(pos.x*0.5+uTime*2.0)*effectMix*3.0;float waveZ=cos(pos.z*0.5+uTime*1.5)*effectMix*2.0;float waveY=sin(pos.x*0.3+pos.z*0.3+uTime*2.5)*effectMix*4.0;waveY+=sin(pos.x*0.8-uTime*1.8)*effectMix*1.5;waveY+=cos(pos.z*0.6+uTime*1.2)*effectMix*1.0;pos.x+=waveX*0.3;pos.y+=waveY;pos.z+=waveZ*0.3;}vec4 mvPosition=modelViewMatrix*vec4(pos,1.0);float dist=length(pos);vDistance=dist;float sizeMultiplier=1.0;if(uEffectMode==2&&effectMix>0.1)sizeMultiplier=1.0+sin(uExplosionTime*10.0)*0.3;if(uEffectMode==4)sizeMultiplier=1.0+sin(uTime*2.5)*0.2*effectMix;gl_PointSize=(uPointSize/-mvPosition.z)*(1.2+sin(uTime*3.0+dist*0.15)*0.5)*sizeMultiplier;gl_Position=projectionMatrix*mvPosition;}`,
      fragmentShader: `uniform float uTime;varying vec3 vColor;varying float vDistance;void main(){float dist=distance(gl_PointCoord,vec2(0.5));if(dist>0.5)discard;float strength=pow(1.0-dist*2.0,1.6);vec3 finalColor=vColor*2.0;float alpha=strength*(0.8+sin(vDistance*0.3+uTime)*0.2);gl_FragColor=vec4(finalColor,alpha);}`
    }
  },
  mounted() {
    this.initData()
    this.initParticleCanvas()
  },
  beforeDestroy() {
    this.destroyScene()
  },
  methods: {
    initData() {
      this.uploadedImage = this.CONFIG.uploadedImage
      this.particleSize = this.CONFIG.particleSize
      this.PARTICLE_COUNT = this.CONFIG.particleCount
      this.currentEffect = this.CONFIG.effect
      this.currentShape = this.CONFIG.shape
      this.interactionMode = this.CONFIG.interactionMode
      this.manualControlTarget = this.CONFIG.manualControlTarget
    },
    updateCameraFromState(camera) {
      const cp = Math.cos(this.cameraControlState.pitch)
      const sp = Math.sin(this.cameraControlState.pitch)
      const cy = Math.cos(this.cameraControlState.yaw)
      const sy = Math.sin(this.cameraControlState.yaw)
      camera.position.set(
        this.cameraControlState.target.x + this.cameraControlState.distance * sy * cp,
        this.cameraControlState.target.y + this.cameraControlState.distance * sp,
        this.cameraControlState.target.z + this.cameraControlState.distance * cy * cp
      )
      camera.lookAt(this.cameraControlState.target)
    },
    initParticleCanvas() {
      const container = this.$refs.container
      const width = window.innerWidth
      const height = window.innerHeight

      const scene = new THREE.Scene()
      const camera = new THREE.PerspectiveCamera(35, width / height, 0.1, 1000)
      camera.position.z = 45
      this.cameraControlState.target = new THREE.Vector3(0, 0, 0)
      this.updateCameraFromState(camera)

      const renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
        powerPreference: 'high-performance'
      })
      renderer.setSize(width, height)
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
      renderer.setClearColor(0x000000, 0)
      container.appendChild(renderer.domElement)

      const geometry = new THREE.BufferGeometry()
      const positions = new Float32Array(this.PARTICLE_COUNT * 3)
      const targetPositions = new Float32Array(this.PARTICLE_COUNT * 3)
      const colors = new Float32Array(this.PARTICLE_COUNT * 3)
      const targetColors = new Float32Array(this.PARTICLE_COUNT * 3)
      const randomOffsets = new Float32Array(this.PARTICLE_COUNT * 3)

      const greenColor = new THREE.Color(0x00ff66)
      const brightWhite = new THREE.Color(0xffffff)

      for (let i = 0; i < this.PARTICLE_COUNT; i++) {
        const i3 = i * 3
        const t = (Math.random() - 0.5) * 5.0
        const angle = Math.random() * Math.PI * 2
        const radiusBase = 0.4 + Math.pow(Math.abs(t), 2.4)
        const radius = radiusBase * (0.75 + Math.random() * 0.55)
        let x = radius * Math.cos(angle) * 2.9
        let z = radius * Math.sin(angle) * 2.9
        let y = t * 7.5

        positions[i3] = x
        positions[i3 + 1] = y
        positions[i3 + 2] = z

        targetPositions[i3] = x
        targetPositions[i3 + 1] = y
        targetPositions[i3 + 2] = z

        randomOffsets[i3] = (Math.random() - 0.5) * 2
        randomOffsets[i3 + 1] = (Math.random() - 0.5) * 2
        randomOffsets[i3 + 2] = (Math.random() - 0.5) * 2

        const color = Math.random() > 0.7 ? greenColor : brightWhite
        colors[i3] = color.r
        colors[i3 + 1] = color.g
        colors[i3 + 2] = color.b

        targetColors[i3] = color.r
        targetColors[i3 + 1] = color.g
        targetColors[i3 + 2] = color.b
      }

      geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
      geometry.setAttribute('targetPosition', new THREE.BufferAttribute(targetPositions, 3))
      geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))
      geometry.setAttribute('targetColor', new THREE.BufferAttribute(targetColors, 3))
      geometry.setAttribute('randomOffset', new THREE.BufferAttribute(randomOffsets, 3))

      const material = new THREE.ShaderMaterial({
        vertexShader: this.vertexShader,
        fragmentShader: this.fragmentShader,
        transparent: true,
        uniforms: {
          uTime: { value: 0 },
          uMorph: { value: 0 },
          uPointSize: { value: this.particleSize },
          uEffectMode: { value: this.CONFIG.effectMode },
          uEffectIntensity: { value: 0 },
          uExplosionTime: { value: 0 }
        },
        depthWrite: false,
        blending: THREE.AdditiveBlending
      })

      const points = new THREE.Points(geometry, material)
      scene.add(points)

      points.rotation.y = 1.0;   // 左右旋转
      points.rotation.x = 0.2;   // 上下倾斜
      points.rotation.z = 5.0;   // 整体扭转

      this.sceneData = {
        scene,
        camera,
        renderer,
        points,
        geometry,
        material,
        originalPositions: positions.slice(),
        targetPositions,
        originalColors: colors.slice(),
        targetColors
      }

      if (this.uploadedImage) {
        this.processImage(this.uploadedImage)
      } else if (this.currentShape && this.currentShape !== 'default') {
        this.generateShape(this.currentShape)
      }

      this.animate()
      this.bindEvents()
    },
    animate() {
      if (!this.sceneData) return
      this.animationId = requestAnimationFrame(() => this.animate())

      let time = 0
      let morphFactor = 0
      const effectModes = {
        default: 0,
        scatter: 1,
        explode: 2,
        vortex: 3,
        pulse: 4,
        wave: 5
      }

      time += 0.008
      const { renderer, scene, camera, points, material } = this.sceneData

      if (this.interactionMode === 'manual') {
        if (this.manualControlTarget === 'camera') {
          this.updateCameraFromState(camera)
        }
      } else {
        let rotationSpeed = 0.0025
        if (this.currentEffect === 'vortex') {
          rotationSpeed = 0.008 * (0.5 + this.effectIntensity)
        } else if (this.currentEffect === 'explode' && this.explosionTriggered) {
          rotationSpeed = 0.001
        }
        points.rotation.y += rotationSpeed
        points.rotation.z += 0.001
        points.rotation.x = Math.sin(time * 0.15) * 0.12
      }

      material.uniforms.uTime.value = time
      const targetMorph = this.uploadedImage ? 1.0 : 0.0
      morphFactor += (targetMorph - morphFactor) * 0.05
      material.uniforms.uMorph.value = morphFactor

      this.effectIntensity += (this.targetEffectIntensity - this.effectIntensity) * 0.08
      material.uniforms.uEffectIntensity.value = this.effectIntensity
      material.uniforms.uEffectMode.value = effectModes[this.currentEffect] || 0

      if (this.explosionTriggered) {
        this.explosionTime += 0.016
        if (this.explosionTime > 2.0) this.explosionTime = 0
      }
      material.uniforms.uExplosionTime.value = this.explosionTime

      renderer.render(scene, camera)
    },
    bindEvents() {
      window.addEventListener('resize', this.handleResize)
      const dom = this.sceneData.renderer.domElement
      dom.addEventListener('mousedown', this.handleMouseDown)
      window.addEventListener('mousemove', this.handleMouseMove)
      window.addEventListener('mouseup', this.handleMouseUp)
      dom.addEventListener('wheel', this.handleWheel, { passive: false })
      dom.addEventListener('contextmenu', e => e.preventDefault())
      window.addEventListener('keydown', this.handleKeyDown)
    },
    handleResize() {
      if (!this.sceneData) return
      this.sceneData.camera.aspect = window.innerWidth / window.innerHeight
      this.sceneData.camera.updateProjectionMatrix()
      this.sceneData.renderer.setSize(window.innerWidth, window.innerHeight)
    },
    handleMouseDown(e) {
      if (this.interactionMode === 'manual' && this.manualControlTarget === 'camera') {
        if (e.button === 0) {
          this.cameraControlState.isLeftDragging = true
        } else if (e.button === 2) {
          this.cameraControlState.isRightDragging = true
        }
        this.cameraControlState.previousX = e.clientX
        this.cameraControlState.previousY = e.clientY
      }
      if (this.interactionMode === 'manual' && this.manualControlTarget === 'object') {
        this.mouseState.isDragging = true
        this.mouseState.previousX = e.clientX
        this.mouseState.previousY = e.clientY
      }
    },
    handleMouseMove(e) {
      if (!this.sceneData) return
      if (this.interactionMode === 'manual' && this.manualControlTarget === 'camera') {
        const deltaX = e.clientX - this.cameraControlState.previousX
        const deltaY = e.clientY - this.cameraControlState.previousY
        if (this.cameraControlState.isLeftDragging) {
          this.cameraControlState.yaw -= deltaX * 0.005
          this.cameraControlState.pitch -= deltaY * 0.005
          const maxPitch = Math.PI * 0.499
          this.cameraControlState.pitch = Math.max(Math.min(this.cameraControlState.pitch, maxPitch), -maxPitch)
        } else if (this.cameraControlState.isRightDragging) {
          const panScale = this.cameraControlState.distance * 0.002
          const forward = new THREE.Vector3()
          this.sceneData.camera.getWorldDirection(forward)
          const right = new THREE.Vector3().crossVectors(forward, this.sceneData.camera.up).normalize()
          const up = new THREE.Vector3().copy(this.sceneData.camera.up).normalize()
          this.cameraControlState.target.addScaledVector(right, -deltaX * panScale)
          this.cameraControlState.target.addScaledVector(up, deltaY * panScale)
        }
        this.cameraControlState.previousX = e.clientX
        this.cameraControlState.previousY = e.clientY
      }
      if (this.interactionMode === 'manual' && this.manualControlTarget === 'object' && this.mouseState.isDragging) {
        const deltaX = e.clientX - this.mouseState.previousX
        const deltaY = e.clientY - this.mouseState.previousY
        this.sceneData.points.rotation.y += deltaX * 0.005
        this.sceneData.points.rotation.x += deltaY * 0.005
        this.mouseState.previousX = e.clientX
        this.mouseState.previousY = e.clientY
      }
    },
    handleMouseUp() {
      this.mouseState.isDragging = false
      this.cameraControlState.isLeftDragging = false
      this.cameraControlState.isRightDragging = false
    },
    handleWheel(e) {
      if (this.interactionMode === 'manual' && this.manualControlTarget === 'camera') {
        e.preventDefault()
        this.cameraControlState.distance += e.deltaY * 0.03
        this.cameraControlState.distance = Math.max(
          Math.min(this.cameraControlState.distance, this.cameraControlState.maxDistance),
          this.cameraControlState.minDistance
        )
      }
    },
    handleKeyDown(e) {
      if (e.code === 'Space' && !e.repeat) {
        e.preventDefault()
        this.interactionMode = this.interactionMode === 'auto' ? 'manual' : 'auto'
      }
    },
    processImage(imageUrl) {
      if (!imageUrl || !this.sceneData) return
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = imageUrl
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const resolution = 200
        const aspect = img.width / img.height
        let drawWidth = aspect > 1 ? resolution : resolution * aspect
        let drawHeight = aspect > 1 ? resolution / aspect : resolution
        canvas.width = resolution
        canvas.height = resolution
        ctx.fillStyle = 'black'
        ctx.fillRect(0, 0, resolution, resolution)
        ctx.drawImage(img, (resolution - drawWidth) / 2, (resolution - drawHeight) / 2, drawWidth, drawHeight)
        const imgData = ctx.getImageData(0, 0, resolution, resolution).data
        const validPoints = []
        for (let y = 0; y < resolution; y++) {
          for (let x = 0; x < resolution; x++) {
            const idx = (y * resolution + x) * 4
            const r = imgData[idx]
            const g = imgData[idx + 1]
            const b = imgData[idx + 2]
            if ((r + g + b) / 3 > 15) {
              validPoints.push({
                pos: [(x / resolution - 0.5) * 38, (0.5 - y / resolution) * 38, ((r + g + b) / 765 - 0.5) * 12],
                col: [r / 255, g / 255, b / 255]
              })
            }
          }
        }
        if (validPoints.length > 0) {
          const { targetPositions, targetColors, geometry } = this.sceneData
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const i3 = i * 3
            const point = validPoints[i % validPoints.length]
            targetPositions[i3] = point.pos[0] + (Math.random() - 0.5) * 0.4
            targetPositions[i3 + 1] = point.pos[1] + (Math.random() - 0.5) * 0.4
            targetPositions[i3 + 2] = point.pos[2] + (Math.random() - 0.5) * 1.5
            targetColors[i3] = point.col[0]
            targetColors[i3 + 1] = point.col[1]
            targetColors[i3 + 2] = point.col[2]
          }
          geometry.attributes.targetPosition.needsUpdate = true
          geometry.attributes.targetColor.needsUpdate = true
        }
      }
    },
    generateShape(shapeName) {
      if (!this.sceneData) return
      const { targetPositions, targetColors, geometry } = this.sceneData
      const points = []
      const shapeGreen = new THREE.Color(0x00ff66)
      const shapeWhite = new THREE.Color(0xffffff)

      switch (shapeName) {
        case 'heart':
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const t = (i / this.PARTICLE_COUNT) * Math.PI * 2
            const u = Math.random() * Math.PI * 2
            const v = Math.random() * Math.PI
            const scale = 18
            const x = scale * (16 * Math.pow(Math.sin(t), 3)) / 16 * Math.sin(v) * Math.cos(u)
            const y = scale * (13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t)) / 16
            const z = scale * (16 * Math.pow(Math.sin(t), 3)) / 16 * Math.sin(v) * Math.sin(u) * 0.8
            const spread = 3.0
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y + (Math.random() - 0.5) * spread, z + (Math.random() - 0.5) * spread],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'butterfly':
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const t = (i / this.PARTICLE_COUNT) * Math.PI * 12
            const scale = 5.5
            const exp = Math.exp(Math.cos(t)) - 2 * Math.cos(4 * t) - Math.pow(Math.sin(t / 12), 5)
            const x = Math.sin(t) * exp * scale
            const y = Math.cos(t) * exp * scale
            const z = (Math.random() - 0.5) * 15
            const spread = 2.5
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y + (Math.random() - 0.5) * spread, z],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'rose':
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const t = (i / this.PARTICLE_COUNT) * Math.PI * 14
            const k = 5
            const r = Math.cos(k * t) * 15
            const h = (Math.random() - 0.5) * 20
            const x = r * Math.cos(t)
            const y = h
            const z = r * Math.sin(t)
            const spread = 2.0
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y, z + (Math.random() - 0.5) * spread],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'cube':
          const cubeSize = 18
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const face = Math.floor(Math.random() * 6)
            let x, y, z
            const a = (Math.random() - 0.5) * cubeSize
            const b = (Math.random() - 0.5) * cubeSize
            switch (face) {
              case 0: x = cubeSize / 2; y = a; z = b; break
              case 1: x = -cubeSize / 2; y = a; z = b; break
              case 2: x = a; y = cubeSize / 2; z = b; break
              case 3: x = a; y = -cubeSize / 2; z = b; break
              case 4: x = a; y = b; z = cubeSize / 2; break
              case 5: x = a; y = b; z = -cubeSize / 2; break
            }
            const spread = 2.0
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y + (Math.random() - 0.5) * spread, z + (Math.random() - 0.5) * spread],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'pyramid':
          const pyrHeight = 25
          const pyrBase = 20
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const onBase = Math.random() < 0.3
            let x, y, z
            if (onBase) {
              x = (Math.random() - 0.5) * pyrBase
              z = (Math.random() - 0.5) * pyrBase
              y = -pyrHeight / 2
            } else {
              const t = Math.random()
              const baseX = (Math.random() - 0.5) * pyrBase * (1 - t)
              const baseZ = (Math.random() - 0.5) * pyrBase * (1 - t)
              x = baseX
              y = -pyrHeight / 2 + t * pyrHeight
              z = baseZ
            }
            const spread = 2.0
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y + (Math.random() - 0.5) * spread, z + (Math.random() - 0.5) * spread],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'spiral':
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const t = (i / this.PARTICLE_COUNT) * Math.PI * 10
            const r = 10 + Math.sin(t * 3) * 4
            const x = r * Math.cos(t)
            const y = (i / this.PARTICLE_COUNT - 0.5) * 40
            const z = r * Math.sin(t)
            const spread = 2.5
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y + (Math.random() - 0.5) * spread, z + (Math.random() - 0.5) * spread],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'star':
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const angle = Math.random() * Math.PI * 2
            const starPoints = 5
            const innerR = 8
            const outerR = 18
            const pointAngle = Math.floor(angle / (Math.PI * 2 / starPoints)) * (Math.PI * 2 / starPoints)
            const t = (angle - pointAngle) / (Math.PI / starPoints)
            let r
            if (t < 1) {
              r = outerR - (outerR - innerR) * t
            } else {
              r = innerR + (outerR - innerR) * (t - 1)
            }
            const x = r * Math.cos(angle)
            const z = r * Math.sin(angle)
            const y = (Math.random() - 0.5) * 15
            const spread = 2.0
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y, z + (Math.random() - 0.5) * spread],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'sphere':
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const theta = Math.random() * Math.PI * 2
            const phi = Math.acos(2 * Math.random() - 1)
            const r = 16
            const x = r * Math.sin(phi) * Math.cos(theta)
            const y = r * Math.sin(phi) * Math.sin(theta)
            const z = r * Math.cos(phi)
            const spread = 5
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y + (Math.random() - 0.5) * spread, z + (Math.random() - 0.5) * spread],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'dna':
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const t = (i / this.PARTICLE_COUNT) * Math.PI * 8
            const y = (i / this.PARTICLE_COUNT - 0.5) * 45
            const r = 10
            const strand = i % 3
            let x, z
            if (strand === 0) {
              x = r * Math.cos(t)
              z = r * Math.sin(t)
            } else if (strand === 1) {
              x = r * Math.cos(t + Math.PI)
              z = r * Math.sin(t + Math.PI)
            } else {
              const barPos = Math.random()
              x = r * Math.cos(t) * (1 - barPos) + r * Math.cos(t + Math.PI) * barPos
              z = r * Math.sin(t) * (1 - barPos) + r * Math.sin(t + Math.PI) * barPos
            }
            const spread = 2.0
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + (Math.random() - 0.5) * spread, y + (Math.random() - 0.5) * spread, z + (Math.random() - 0.5) * spread],
              col: [color.r, color.g, color.b]
            })
          }
          break
        case 'infinity':
          const infScale = 25
          for (let i = 0; i < this.PARTICLE_COUNT; i++) {
            const t = (i / this.PARTICLE_COUNT) * Math.PI * 6
            const denom = 1 + Math.sin(t) * Math.sin(t)
            let x = infScale * Math.cos(t) / denom
            let y = infScale * Math.sin(t) * Math.cos(t) / denom
            const verticalSpread = (Math.random() - 0.5) * 20
            const z = (Math.random() - 0.5) * 15 + Math.sin(t * 2) * 5
            const thickness = 4.0
            const offsetX = (Math.random() - 0.5) * thickness
            const offsetY = (Math.random() - 0.5) * thickness + verticalSpread * 0.3
            const offsetZ = (Math.random() - 0.5) * thickness
            const color = Math.random() > 0.7 ? shapeGreen : shapeWhite
            points.push({
              pos: [x + offsetX, y + offsetY, z + offsetZ],
              col: [color.r, color.g, color.b]
            })
          }
          break
      }

      if (points.length > 0) {
        for (let i = 0; i < this.PARTICLE_COUNT; i++) {
          const i3 = i * 3
          const point = points[i % points.length]
          targetPositions[i3] = point.pos[0]
          targetPositions[i3 + 1] = point.pos[1]
          targetPositions[i3 + 2] = point.pos[2]
          targetColors[i3] = point.col[0]
          targetColors[i3 + 1] = point.col[1]
          targetColors[i3 + 2] = point.col[2]
        }
        geometry.attributes.targetPosition.needsUpdate = true
        geometry.attributes.targetColor.needsUpdate = true
        this.uploadedImage = 'shape'
      }
    },
    destroyScene() {
      cancelAnimationFrame(this.animationId)
      if (this.sceneData) {
        const { renderer, scene, geometry, material } = this.sceneData
        scene.remove(this.sceneData.points)
        geometry.dispose()
        material.dispose()
        renderer.dispose()
        this.sceneData = null
      }
      window.removeEventListener('resize', this.handleResize)
      window.removeEventListener('mousemove', this.handleMouseMove)
      window.removeEventListener('mouseup', this.handleMouseUp)
      window.removeEventListener('keydown', this.handleKeyDown)
    }
  }
}
</script>

<style scoped>
.particle-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: transparent;
}
</style>